/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimImageRequest } from './CreateClaimImageRequest';
export type ReceiverConfirmClaimRequest = {
    receiverShopId: string;
    status: ReceiverConfirmClaimRequest.status;
    note?: string;
    images: Array<CreateClaimImageRequest>;
};
export namespace ReceiverConfirmClaimRequest {
    export enum status {
        RECEIVE = 'RECEIVE',
        CANCEL = 'CANCEL',
    }
}

